export default __webpack_public_path__ + "4bc92ef7154478710df86761d5a199ff.png";